export const getAppsData = (state) => state.integrations.appsData;
export const getShowNextModal = (state) => state?.integrations?.showNextModal;
export const getShowAppDetailsModal = (state) => state?.integrations?.showAppDetailsModal;
export const getSelectedApp = (state) => state?.integrations?.selectedApp;
export const getLimitExceededForAppIntegartion = (state) =>
  state?.integrations?.limitExceedForAppIntegration;
export const getWhatsAppPayStatus = (state) =>
  state?.integrations?.whatsAppPayStatus;
